import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { CoreModule } from '@core/core.module';
import { NgApexchartsModule } from 'ng-apexcharts';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { MessageService, SharedModule } from 'primeng/api';
import { ComponentsModule } from 'src/app/components/components.module';
import { MaterialModule } from 'src/app/material.module';
import { PrimeNgModule } from 'src/app/primeng.module';
import { ActivityChartComponent } from './analytics-dashboard/activity-chart/activity-chart.component';
import { AnalyticsDashboardComponent } from './analytics-dashboard/analytics-dashboard.component';
import { EventsTableComponent } from './analytics-dashboard/events-table/events-table.component';
import { FunnelChartComponent } from './analytics-dashboard/funnel-chart/funnel-chart.component';
import { StatsBreakdownComponent } from './analytics-dashboard/stats-breakdown/stats-breakdown.component';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { InteractionsMsgComponent } from './interactions-msg/interactions-msg.component';

@NgModule({
  declarations: [
    InteractionsMsgComponent,
    AnalyticsDashboardComponent,
    ActivityChartComponent,
    EventsTableComponent,
    FunnelChartComponent,
    StatsBreakdownComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    DashboardRoutingModule,
    MaterialModule,
    CoreModule,
    ComponentsModule,
    NgScrollbarModule,
    SharedModule,
    PrimeNgModule,
    NgApexchartsModule,
  ],
  providers: [MessageService],
})
export class DashboardModule {}
